module.exports = __webpack_public_path__ + "static/media/whack_img_2.7d12653e.png";